export default "__VITE_PUBLIC_ASSET__df133cf0__"